<template>
    <div id="app">
        <stb-header
            v-if="['login', 'registration', 'forgot-password', 'set-password'].indexOf($route.name) < 0"
        ></stb-header>
        <router-view />
        <stb-navigation v-if="['login', 'registration', 'forgot-password', 'set-password', 'announcements', 'impressum', 'datenschutz', 'nutzungsbedingungen'].indexOf($route.name) < 0"></stb-navigation>
    </div>
</template>

<script>
export default {
  name: 'App'
}

</script>

<style lang="scss">


</style>



// WEBPACK FOOTER //
// src/App.vue